/* ==========================================================================
   BOUNTEOUS CONFIDENTIAL
   ___________________

   Copyright 2019 Bounteous
   All Rights Reserved.

   NOTICE:  All information contained herein is, and remains the property
   of Bounteous and its suppliers, if any. The intellectual and
   technical concepts contained herein are proprietary to Bounteous
   and its suppliers and are protected by trade secret or copyright law.
   Dissemination of this information or reproduction of this material
   is strictly forbidden unless prior written permission is obtained
   from Bounteous.
   ========================================================================== */

import { Component, registerComponent } from 'js/component.js';

const componentName = 'cmp-footer__language-navigation';
const languageNavName = 'cmp-languagenavigation';
const languageNavActiveName = `${languageNavName}--active`;
const dropdownIconActiveName = 'fa-angle-up';
const dropdownIconInactiveName = 'fa-angle-down';

export class Footer extends Component {

    /**
     * Set Up Language Nav
     */
    setupLanguageNav() {
        // Update Top Position of Nav
        const navHeight = this.elements.languageNav.clientHeight;
        this.elements.languageNav.style.top = `-${navHeight}px`;

        // Update Number of Available Languages
        const numLanguages = this.elements.languageNavItems.length || 1;
        this.languages = numLanguages;

        // Update Active (or Default) Language Text
        const activeLanguage = this.elements.languageNavActiveItem();
        if(activeLanguage) {
            const languageText = activeLanguage.textContent;
            this.elements.dropdownTitleText.textContent = languageText;
        } else {
            this.elements.dropdownTitleText.textContent = this.defaultTitle;
        }
    }

    /**
     * Check if Language Nav is Open
     */
    isLanguageNavOpen() {
        return this.elements.languageNav.classList.contains(languageNavActiveName);
    }

    /**
     * Toggle Language Nav
     */
    toggleNav() {
        this.elements.languageNav.classList.toggle(languageNavActiveName);
        this.elements.dropdownIcon.classList.toggle(dropdownIconActiveName);
        this.elements.dropdownIcon.classList.toggle(dropdownIconInactiveName);
    }

    /**
     * Add Event Listeners
     */
    addEventListeners() {
        const classScope = this;

        // Language Nav Toggle Click
        function onLanguageNavClick() {
            classScope.toggleNav();
        }

        // Document Close on Click
        function onDocumentClick(e) {
            if (!classScope.element.contains(e.target) && classScope.isLanguageNavOpen()) {
                classScope.toggleNav();
            }
        }

        // Assign Listeners
        if(classScope.languages > 1) {
            this.elements.dropdownTitle.addEventListener('click', onLanguageNavClick);
            document.addEventListener('click', onDocumentClick);
        }
    }

    /**
     * Initialize Component
     */
    init() {
        // Set Up Elements
        this.elements = {
            languageNav: this.element.querySelector(`.${languageNavName}`),
            languageNavItems: this.element.getElementsByClassName(`${languageNavName}__item`),
            languageNavActiveItem: () => this.element.querySelector(`.${languageNavName}__item--active`),
            dropdownIcon: this.element.querySelector(`.${componentName}__dropdown-title i`),
            dropdownTitle: this.element.querySelector(`.${componentName}__dropdown-title`),
            dropdownTitleText: this.element.querySelector(`.${componentName}__dropdown-title-text`),
        };

        if (this.elements.languageNav) {
            // Set Up Data
            this.defaultTitle = 'English';
            this.languages = 1;

            // Fire Init Funcs
            this.setupLanguageNav();
            this.addEventListeners();
        }
    }

}

registerComponent(`.${componentName}`, Footer);
